export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const QR_CAM = 'QR_CAM';
export const QR_IMAGE = 'QR_IMAGE';